'use client';
import { chakra } from '@chakra-ui/react';
import NextImage from 'next/image';
import { interopDefault } from './interop.mjs';

const ImageEl = interopDefault(NextImage);
const imageProps = [
  "src",
  "alt",
  "sizes",
  "width",
  "height",
  "fill",
  "loader",
  "quality",
  "priority",
  "loading",
  "placeholder",
  "blurDataURL",
  "unoptimized",
  "onLoadingComplete",
  "alt",
  "crossOrigin",
  "decoding",
  "loading",
  "referrerPolicy",
  "sizes",
  "src",
  "useMap"
];
const Image = chakra(ImageEl, {
  shouldForwardProp: (prop) => imageProps.includes(prop)
});

export { Image };
